export const RedesignPreference = Object.freeze({
    dismissed: 'dismissed',
    optIn: 'optIn',
    optOut: 'optOut',
    none: 'none',
});
